import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import genreFetch from "../../redux/genre/genreAction";

// Components
import GenreCard from "../../components/genres/card";
import CardShimmer from "../../components/genres/card_shimmer";
import Breadcrumb from "../../components/breadcrumb/index";

const Index = () => {
  const dispatch = useDispatch();
  const genreState = useSelector((state) => state.genreState);

  useEffect(() => {
    dispatch(genreFetch());
  }, [dispatch]);
  let ArrS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  return (
    <>
      <div className="p-4 lg:px-24">
        <Breadcrumb />
        {genreState.loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {ArrS.map((index) => (
              <CardShimmer key={index} />
            ))}
          </div>
        ) : genreState.error ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {ArrS.map((index) => (
              <CardShimmer key={index} />
            ))}
          </div>
        ) : genreState.genres ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {genreState.genres.map((item) => (
              <GenreCard key={item.id} data={item} />
            ))}
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default Index;
